
import { InterceptMiddle } from '../../regular';
/**
 * 计算各填空题的答案长度
 * @param condition 条件str
 * @param list 试题list
 * @return Boolean
 */
export const Length = (list, condition) => {
    // Length[Q1]
    if (!condition) return false
    let reg = /(\==|>|>=|<|<=)(.+?)(?=\])/ig
    let result = false
    try {
        let code = InterceptMiddle(condition, ['['], ['==', '>', '>=', '<', '<=', '_', ':'])
        let num2 = InterceptMiddle(condition, [':'], ['==', '>', '>=', '<', '<=',])
        num2 = Number(num2)
        list.forEach(info => {
            if (code == info.quesCode && info.bindIsShow && info.isShow) {
                // 2,3,4,5,35,34
                let value = condition.match(reg) ? condition.match(reg)[0] : condition.match(reg)
                switch(info.questionsTypeId) {
                    case '2':
                    case '3':
                    case '4':
                    case '5':
                        result = eval(info.userAnswer.length + value)
                        break 
                    case '34':
                    case '35':
                        if (num2 && eval(info.optionList[num2 - 1].userAnswer.length + value)) {
                            result = true
                        }
                        break 
                }
            }
        })
        return result;
    } catch (error) {
        console.log('error :>> ', error);
        return false
    }
}